import React from "react";

import PropTypes from "prop-types";

import RbLabeledGrid from "components/RbLabeledGrid";
import useFormatters from "hooks/useFormatters";

function ProductDetail({ product }) {
  const { formatCurrency } = useFormatters();

  return (
    <RbLabeledGrid container p={2} rowGap={2} columnGap={2}>
      <Item label="Name" xs={12} lg={4}>
        {product.name}
      </Item>
      <Item label="Code" xs={6} lg={2}>
        {product.code}
      </Item>
      <Item label="Price" xs={6} lg={2}>
        {formatCurrency(product.price) || "--"}
      </Item>
      <Item label="Inventory" xs={6} lg={2}>
        {product.inventory}
      </Item>
      <Item label="Status" xs={6} lg={2}>
        {product.status || "--"}
      </Item>
      <Item label="Manufacturer" xs={12} lg={6}>
        {product.manufacturer?.name}
      </Item>
      <Item label="Thumbnail URL" xs={12} lg={6}>
        {product.thumbnailUrl || "--"}
      </Item>
      <Item label="Categories" xs={12} lg={6}>
        {product?.categories.map((c) => c.name).join(", ")}
      </Item>
      <Item item label="Public" xs={12} lg={6}>
        {product.public ? "Yes" : "No"}
      </Item>
      <Item label="Description" xs={12} lg={12}>
        {product.description}
      </Item>
    </RbLabeledGrid>
  );
}

ProductDetail.propTypes = {
  product: PropTypes.shape({
    categories: PropTypes.array,
    code: PropTypes.string,
    description: PropTypes.string,
    inventory: PropTypes.number,
    manufacturer: PropTypes.shape({
      name: PropTypes.string,
    }),
    name: PropTypes.string,
    price: PropTypes.number,
    public: PropTypes.bool,
    status: PropTypes.string,
    thumbnailUrl: PropTypes.string,
  }).isRequired,
};

function Item(props) {
  return (
    <RbLabeledGrid item px={2} py={1} bgcolor="custom.bg.100" {...props} />
  );
}

export default React.memo(ProductDetail);
